import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBox } from '../context/BoxContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { toggleBox, getTotalItems } = useBox();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const totalItems = getTotalItems();

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img 
              src="https://i.postimg.cc/t4xTCC3x/Firefly-Remove-Background.png" 
              alt="Logo El Hiba Para" 
              style={{
                height: '60px',
                width: 'auto',
                objectFit: 'contain',
                marginRight: '8px'
              }}
            />
            El Hiba Para
          </Link>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'nav-links-open' : ''}`}>
            <li>
              <Link 
                to="/" 
                className={isActive('/')}
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="fas fa-home"></i>
                Accueil
              </Link>
            </li>
            <li>
              <Link 
                to="/products" 
                className={isActive('/products')}
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="fas fa-pills"></i>
                Produits
              </Link>
            </li>
            <li>
              <Link 
                to="/promotions" 
                className={`${isActive('/promotions')} promotions-link`}
                onClick={() => setIsMenuOpen(false)}
                style={{
                  background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
                  color: 'white',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  boxShadow: '0 2px 8px rgba(231, 76, 60, 0.3)',
                  transition: 'all 0.3s ease',
                  border: '2px solid transparent'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #c0392b, #a93226)';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(231, 76, 60, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #e74c3c, #c0392b)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 8px rgba(231, 76, 60, 0.3)';
                }}
              >
                <i className="fas fa-tags"></i>
                Promotions
              </Link>
            </li>
            <li>
              <Link 
                to="/blog" 
                className={isActive('/blog')}
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="fas fa-newspaper"></i>
                Blog
              </Link>
            </li>
            <li>
              <button
                onClick={() => {
                  toggleBox();
                  setIsMenuOpen(false);
                }}
                className="box-btn"
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'inherit',
                  cursor: 'pointer',
                  fontSize: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  position: 'relative',
                  padding: '0.5rem',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <i className="fas fa-shopping-cart"></i>
                Panier
                {totalItems > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    background: '#ef4444',
                    color: 'white',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600'
                  }}>
                    {totalItems > 99 ? '99+' : totalItems}
                  </span>
                )}
              </button>
            </li>
            {/*<li>
              <Link 
                to="/admin/login" 
                className="admin-login"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="fas fa-user-shield"></i>
                Admin
              </Link>
            </li>*/}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;